export default "__VITE_ASSET__D$HGaTPa__"